// a very intense polyfill for crypto.subtle
// this is to handle the case where the browser is a very old version of safari for Auth0
if (window.crypto) {
    window.crypto.subtle = window.crypto.subtle || window.crypto.webkitSubtle;
}